const BaseComponent = require('base/base-component');

class mapNav extends BaseComponent {
    init() {
        // 贵港
        const geoJson = {
            type: "FeatureCollection",
            features: [
                {
                    type: "Feature",
                    properties: {
                        name: "港北区"
                    },
                    geometry: {
                        type: "MultiPolygon",
                        coordinates: [
                            [
                                [
                                    [
                                        109.841790800781,
                                        23.1282888007813
                                    ],
                                    [
                                        109.87107546875,
                                        23.10483909375
                                    ],
                                    [
                                        109.857345,
                                        23.093843
                                    ],
                                    [
                                        109.8355871875,
                                        23.1029811835938
                                    ],
                                    [
                                        109.803260527344,
                                        23.0779274726563
                                    ],
                                    [
                                        109.766092558594,
                                        23.0697585273438
                                    ],
                                    [
                                        109.743260527344,
                                        23.1097585273438
                                    ],
                                    [
                                        109.727069121094,
                                        23.1179274726563
                                    ],
                                    [
                                        109.713016386719,
                                        23.0975710273438
                                    ],
                                    [
                                        109.667037382813,
                                        23.1078786445313
                                    ],
                                    [
                                        109.653260527344,
                                        23.0879274726563
                                    ],
                                    [
                                        109.636976347656,
                                        23.0766847968751
                                    ],
                                    [
                                        109.595697050781,
                                        23.0859377265625
                                    ],
                                    [
                                        109.579176054688,
                                        23.0620119453125
                                    ],
                                    [
                                        109.567345,
                                        23.0538430000001
                                    ],
                                    [
                                        109.532469511719,
                                        23.0380959296875
                                    ],
                                    [
                                        109.489527617188,
                                        23.0503591132813
                                    ],
                                    [
                                        109.472203398438,
                                        23.0482033515626
                                    ],
                                    [
                                        109.452899199219,
                                        23.0522731757813
                                    ],
                                    [
                                        109.472899199219,
                                        23.0682888007813
                                    ],
                                    [
                                        109.48297,
                                        23.1488161445313
                                    ],
                                    [
                                        109.481378203125,
                                        23.1616091132813
                                    ],
                                    [
                                        109.439298125,
                                        23.1793410468751
                                    ],
                                    [
                                        109.443917265625,
                                        23.2164846015625
                                    ],
                                    [
                                        109.502899199219,
                                        23.2382888007813
                                    ],
                                    [
                                        109.511790800781,
                                        23.2693971992188
                                    ],
                                    [
                                        109.537345,
                                        23.303843
                                    ],
                                    [
                                        109.561329375,
                                        23.3204030585937
                                    ],
                                    [
                                        109.571429472656,
                                        23.3597585273438
                                    ],
                                    [
                                        109.603260527344,
                                        23.3679274726563
                                    ],
                                    [
                                        109.643663359375,
                                        23.4279274726563
                                    ],
                                    [
                                        109.673260527344,
                                        23.4197585273438
                                    ],
                                    [
                                        109.697345,
                                        23.403843
                                    ],
                                    [
                                        109.720648222656,
                                        23.3971804023438
                                    ],
                                    [
                                        109.751790800781,
                                        23.3582888007813
                                    ],
                                    [
                                        109.778912382813,
                                        23.3468630195313
                                    ],
                                    [
                                        109.801790800781,
                                        23.3182888007813
                                    ],
                                    [
                                        109.821241484375,
                                        23.3027150703126
                                    ],
                                    [
                                        109.822987089844,
                                        23.2886818671875
                                    ],
                                    [
                                        109.809290800781,
                                        23.2283888984375
                                    ],
                                    [
                                        109.814832792969,
                                        23.183843
                                    ],
                                    [
                                        109.811441679688,
                                        23.156577375
                                    ],
                                    [
                                        109.832899199219,
                                        23.1393971992188
                                    ],
                                    [
                                        109.841790800781,
                                        23.1282888007813
                                    ]
                                ]
                            ]
                        ]
                    }
                },
                {
                    type: "Feature",
                    properties: {
                        name: "港南区"
                    },
                    geometry: {
                        type: "MultiPolygon",
                        coordinates: [
                            [
                                [
                                    [
                                        109.861910429688,
                                        22.8865407539063
                                    ],
                                    [
                                        109.867345,
                                        22.873843
                                    ],
                                    [
                                        109.844346953125,
                                        22.8778957343751
                                    ],
                                    [
                                        109.861910429688,
                                        22.8865407539063
                                    ]
                                ]
                            ],
                            [
                                [
                                    [
                                        109.743260527344,
                                        23.1097585273438
                                    ],
                                    [
                                        109.766092558594,
                                        23.0697585273438
                                    ],
                                    [
                                        109.803260527344,
                                        23.0779274726563
                                    ],
                                    [
                                        109.8355871875,
                                        23.1029811835938
                                    ],
                                    [
                                        109.857345,
                                        23.093843
                                    ],
                                    [
                                        109.874823027344,
                                        23.0673928046876
                                    ],
                                    [
                                        109.883260527344,
                                        23.0297585273438
                                    ],
                                    [
                                        109.887345,
                                        23.023843
                                    ],
                                    [
                                        109.88197390625,
                                        23.01921409375
                                    ],
                                    [
                                        109.87271609375,
                                        23.00847190625
                                    ],
                                    [
                                        109.858519316406,
                                        22.9962404609375
                                    ],
                                    [
                                        109.792733183594,
                                        22.9764333320312
                                    ],
                                    [
                                        109.820833769531,
                                        22.95222190625
                                    ],
                                    [
                                        109.84197390625,
                                        22.9184719062501
                                    ],
                                    [
                                        109.853284941406,
                                        22.9087258125001
                                    ],
                                    [
                                        109.827474394531,
                                        22.8972072578125
                                    ],
                                    [
                                        109.792669707031,
                                        22.8568093085938
                                    ],
                                    [
                                        109.762020292969,
                                        22.8592702460938
                                    ],
                                    [
                                        109.751302519531,
                                        22.8468288398438
                                    ],
                                    [
                                        109.756409941406,
                                        22.7832643867188
                                    ],
                                    [
                                        109.783519316406,
                                        22.7599074531251
                                    ],
                                    [
                                        109.770719023438,
                                        22.7369655585938
                                    ],
                                    [
                                        109.742345,
                                        22.7392458320313
                                    ],
                                    [
                                        109.724561796875,
                                        22.7378151679688
                                    ],
                                    [
                                        109.71271609375,
                                        22.69847190625
                                    ],
                                    [
                                        109.671229277344,
                                        22.6799587226563
                                    ],
                                    [
                                        109.657345,
                                        22.6638430000001
                                    ],
                                    [
                                        109.619820585938,
                                        22.6576784492188
                                    ],
                                    [
                                        109.607345,
                                        22.6738430000001
                                    ],
                                    [
                                        109.621422148438,
                                        22.6855373359375
                                    ],
                                    [
                                        109.581795683594,
                                        22.718452375
                                    ],
                                    [
                                        109.582882109375,
                                        22.7291091132813
                                    ],
                                    [
                                        109.569136992188,
                                        22.7656838203126
                                    ],
                                    [
                                        109.511883574219,
                                        22.7783815742188
                                    ],
                                    [
                                        109.502806425781,
                                        22.8017678046875
                                    ],
                                    [
                                        109.523072539063,
                                        22.8186013007813
                                    ],
                                    [
                                        109.517345,
                                        22.833843
                                    ],
                                    [
                                        109.561287871094,
                                        22.8690309882812
                                    ],
                                    [
                                        109.571790800781,
                                        22.9293971992188
                                    ],
                                    [
                                        109.585775175781,
                                        22.9382888007813
                                    ],
                                    [
                                        109.604622832031,
                                        22.9147560859376
                                    ],
                                    [
                                        109.651790800781,
                                        22.9314357734375
                                    ],
                                    [
                                        109.585819121094,
                                        22.959233625
                                    ],
                                    [
                                        109.604476347656,
                                        22.9909743476563
                                    ],
                                    [
                                        109.570213652344,
                                        22.9867116523438
                                    ],
                                    [
                                        109.573023710938,
                                        23.0092971015626
                                    ],
                                    [
                                        109.561102324219,
                                        23.018843
                                    ],
                                    [
                                        109.576163359375,
                                        23.030903546875
                                    ],
                                    [
                                        109.567345,
                                        23.0538430000001
                                    ],
                                    [
                                        109.579176054688,
                                        23.0620119453125
                                    ],
                                    [
                                        109.595697050781,
                                        23.0859377265625
                                    ],
                                    [
                                        109.636976347656,
                                        23.0766847968751
                                    ],
                                    [
                                        109.653260527344,
                                        23.0879274726563
                                    ],
                                    [
                                        109.667037382813,
                                        23.1078786445313
                                    ],
                                    [
                                        109.713016386719,
                                        23.0975710273438
                                    ],
                                    [
                                        109.727069121094,
                                        23.1179274726563
                                    ],
                                    [
                                        109.743260527344,
                                        23.1097585273438
                                    ]
                                ]
                            ]
                        ]
                    }
                },
                {
                    type: "Feature",
                    properties: {
                        name: "桂平市"
                    },
                    geometry: {
                        type: "MultiPolygon",
                        coordinates: [
                            [
                                [
                                    [
                                        110.227345,
                                        22.873843
                                    ],
                                    [
                                        110.227345,
                                        22.8638430000001
                                    ],
                                    [
                                        110.217345,
                                        22.8638430000001
                                    ],
                                    [
                                        110.217345,
                                        22.873843
                                    ],
                                    [
                                        110.227345,
                                        22.873843
                                    ]
                                ]
                            ],
                            [
                                [
                                    [
                                        110.227345,
                                        22.873843
                                    ],
                                    [
                                        110.220074492188,
                                        22.8973903632813
                                    ],
                                    [
                                        110.165589628906,
                                        22.9100685859376
                                    ],
                                    [
                                        110.1117590625,
                                        22.8956520820313
                                    ],
                                    [
                                        110.076009550781,
                                        22.9735402656251
                                    ],
                                    [
                                        110.061585722656,
                                        22.9573976875
                                    ],
                                    [
                                        110.019813261719,
                                        22.959887921875
                                    ],
                                    [
                                        109.96787234375,
                                        23.0180226875001
                                    ],
                                    [
                                        109.887345,
                                        23.023843
                                    ],
                                    [
                                        109.883260527344,
                                        23.0297585273438
                                    ],
                                    [
                                        109.874823027344,
                                        23.0673928046876
                                    ],
                                    [
                                        109.857345,
                                        23.093843
                                    ],
                                    [
                                        109.87107546875,
                                        23.10483909375
                                    ],
                                    [
                                        109.841790800781,
                                        23.1282888007813
                                    ],
                                    [
                                        109.832899199219,
                                        23.1393971992188
                                    ],
                                    [
                                        109.811441679688,
                                        23.156577375
                                    ],
                                    [
                                        109.814832792969,
                                        23.183843
                                    ],
                                    [
                                        109.809290800781,
                                        23.2283888984375
                                    ],
                                    [
                                        109.822987089844,
                                        23.2886818671875
                                    ],
                                    [
                                        109.821241484375,
                                        23.3027150703126
                                    ],
                                    [
                                        109.801790800781,
                                        23.3182888007813
                                    ],
                                    [
                                        109.778912382813,
                                        23.3468630195313
                                    ],
                                    [
                                        109.751790800781,
                                        23.3582888007813
                                    ],
                                    [
                                        109.720648222656,
                                        23.3971804023438
                                    ],
                                    [
                                        109.697345,
                                        23.403843
                                    ],
                                    [
                                        109.701429472656,
                                        23.4097585273438
                                    ],
                                    [
                                        109.723260527344,
                                        23.4179274726563
                                    ],
                                    [
                                        109.731429472656,
                                        23.4597585273438
                                    ],
                                    [
                                        109.773260527344,
                                        23.4679274726563
                                    ],
                                    [
                                        109.781429472656,
                                        23.4797585273438
                                    ],
                                    [
                                        109.836461210938,
                                        23.4879274726563
                                    ],
                                    [
                                        109.851788359375,
                                        23.446968
                                    ],
                                    [
                                        109.878084746094,
                                        23.4640920234375
                                    ],
                                    [
                                        109.898182402344,
                                        23.5178054023438
                                    ],
                                    [
                                        109.889371367188,
                                        23.5571047187501
                                    ],
                                    [
                                        109.913260527344,
                                        23.5879274726562
                                    ],
                                    [
                                        109.924801054688,
                                        23.6328932929688
                                    ],
                                    [
                                        109.918870878906,
                                        23.659341046875
                                    ],
                                    [
                                        109.927345,
                                        23.6938430000001
                                    ],
                                    [
                                        109.955223417969,
                                        23.7009987617188
                                    ],
                                    [
                                        109.951104765625,
                                        23.71937034375
                                    ],
                                    [
                                        109.983260527344,
                                        23.7579274726563
                                    ],
                                    [
                                        109.991429472656,
                                        23.7797585273438
                                    ],
                                    [
                                        110.039176054688,
                                        23.7920119453125
                                    ],
                                    [
                                        110.067345,
                                        23.803843
                                    ],
                                    [
                                        110.079478789063,
                                        23.7614064765625
                                    ],
                                    [
                                        110.117064238281,
                                        23.73931175
                                    ],
                                    [
                                        110.163031035156,
                                        23.7293679023438
                                    ],
                                    [
                                        110.161678496094,
                                        23.7184841132813
                                    ],
                                    [
                                        110.174039335938,
                                        23.69745628125
                                    ],
                                    [
                                        110.170548125,
                                        23.6693971992188
                                    ],
                                    [
                                        110.202899199219,
                                        23.6882888007813
                                    ],
                                    [
                                        110.215538359375,
                                        23.7182888007813
                                    ],
                                    [
                                        110.237703886719,
                                        23.7069338203125
                                    ],
                                    [
                                        110.229405546875,
                                        23.6402028632813
                                    ],
                                    [
                                        110.252376738281,
                                        23.6218068671876
                                    ],
                                    [
                                        110.261820097656,
                                        23.5781569648437
                                    ],
                                    [
                                        110.287843046875,
                                        23.5813918281251
                                    ],
                                    [
                                        110.301790800781,
                                        23.5482888007813
                                    ],
                                    [
                                        110.322899199219,
                                        23.5393971992188
                                    ],
                                    [
                                        110.351790800781,
                                        23.4682888007813
                                    ],
                                    [
                                        110.371790800781,
                                        23.4522731757813
                                    ],
                                    [
                                        110.362899199219,
                                        23.4282888007813
                                    ],
                                    [
                                        110.339549589844,
                                        23.3963259101563
                                    ],
                                    [
                                        110.343016386719,
                                        23.3684499335938
                                    ],
                                    [
                                        110.316673613281,
                                        23.332387921875
                                    ],
                                    [
                                        110.341790800781,
                                        23.3122731757813
                                    ],
                                    [
                                        110.322899199219,
                                        23.2882888007813
                                    ],
                                    [
                                        110.311790800781,
                                        23.2793971992188
                                    ],
                                    [
                                        110.302899199219,
                                        23.2482888007813
                                    ],
                                    [
                                        110.291666289063,
                                        23.2392971015626
                                    ],
                                    [
                                        110.295064726563,
                                        23.2119753242188
                                    ],
                                    [
                                        110.262899199219,
                                        23.1572536445312
                                    ],
                                    [
                                        110.291519804688,
                                        23.1284035468751
                                    ],
                                    [
                                        110.351597929688,
                                        23.1030886054688
                                    ],
                                    [
                                        110.331790800781,
                                        23.0693971992188
                                    ],
                                    [
                                        110.327345,
                                        23.0538430000001
                                    ],
                                    [
                                        110.312547636719,
                                        23.0171022773438
                                    ],
                                    [
                                        110.296263457031,
                                        23.03819846875
                                    ],
                                    [
                                        110.290662871094,
                                        23.0152272773437
                                    ],
                                    [
                                        110.295667753906,
                                        22.9813600898438
                                    ],
                                    [
                                        110.251246367188,
                                        22.928950421875
                                    ],
                                    [
                                        110.263140898438,
                                        22.909233625
                                    ],
                                    [
                                        110.26048953125,
                                        22.8912819648438
                                    ],
                                    [
                                        110.267345,
                                        22.873843
                                    ],
                                    [
                                        110.227345,
                                        22.873843
                                    ]
                                ]
                            ]
                        ]
                    }
                },
                {
                    type: "Feature",
                    properties: {
                        name: "平南县"
                    },
                    geometry: {
                        type: "MultiPolygon",
                        coordinates: [
                            [
                                [
                                    [
                                        110.442625761719,
                                        23.8591237617188
                                    ],
                                    [
                                        110.45209109375,
                                        23.8485305000001
                                    ],
                                    [
                                        110.472345,
                                        23.8497365546876
                                    ],
                                    [
                                        110.495574980469,
                                        23.7991237617188
                                    ],
                                    [
                                        110.532625761719,
                                        23.8085622382813
                                    ],
                                    [
                                        110.550496855469,
                                        23.8285622382813
                                    ],
                                    [
                                        110.578450957031,
                                        23.7837673164062
                                    ],
                                    [
                                        110.552760039063,
                                        23.7608107734375
                                    ],
                                    [
                                        110.549635039063,
                                        23.708384015625
                                    ],
                                    [
                                        110.572064238281,
                                        23.7097194648438
                                    ],
                                    [
                                        110.562625761719,
                                        23.6785622382813
                                    ],
                                    [
                                        110.533465605469,
                                        23.6651784492188
                                    ],
                                    [
                                        110.583343535156,
                                        23.6206130195313
                                    ],
                                    [
                                        110.5820325,
                                        23.59858909375
                                    ],
                                    [
                                        110.592625761719,
                                        23.5891237617188
                                    ],
                                    [
                                        110.602064238281,
                                        23.5685622382812
                                    ],
                                    [
                                        110.6126575,
                                        23.5490676093751
                                    ],
                                    [
                                        110.612039824219,
                                        23.5387038398438
                                    ],
                                    [
                                        110.624014921875,
                                        23.4713088203125
                                    ],
                                    [
                                        110.612625761719,
                                        23.4585622382813
                                    ],
                                    [
                                        110.574913359375,
                                        23.4469167304688
                                    ],
                                    [
                                        110.572047148438,
                                        23.398843
                                    ],
                                    [
                                        110.57322390625,
                                        23.3790969062501
                                    ],
                                    [
                                        110.561749296875,
                                        23.368843
                                    ],
                                    [
                                        110.581798125,
                                        23.3509304023438
                                    ],
                                    [
                                        110.592078886719,
                                        23.3285280585937
                                    ],
                                    [
                                        110.61158328125,
                                        23.3296926093751
                                    ],
                                    [
                                        110.632064238281,
                                        23.3185622382813
                                    ],
                                    [
                                        110.652659941406,
                                        23.3091091132813
                                    ],
                                    [
                                        110.652047148438,
                                        23.298843
                                    ],
                                    [
                                        110.653709746094,
                                        23.2709645820313
                                    ],
                                    [
                                        110.620345488281,
                                        23.2336232734375
                                    ],
                                    [
                                        110.585516386719,
                                        23.2146974921875
                                    ],
                                    [
                                        110.567235136719,
                                        23.2351589179688
                                    ],
                                    [
                                        110.539559355469,
                                        23.1955397773438
                                    ],
                                    [
                                        110.554520292969,
                                        23.153843
                                    ],
                                    [
                                        110.547345,
                                        23.133843
                                    ],
                                    [
                                        110.50170046875,
                                        23.09948753125
                                    ],
                                    [
                                        110.487916289063,
                                        23.0658034492188
                                    ],
                                    [
                                        110.459205351563,
                                        23.0700466132813
                                    ],
                                    [
                                        110.415286894531,
                                        23.0435524726563
                                    ],
                                    [
                                        110.400360136719,
                                        23.0628908515625
                                    ],
                                    [
                                        110.358802519531,
                                        23.0465529609375
                                    ],
                                    [
                                        110.327345,
                                        23.0538430000001
                                    ],
                                    [
                                        110.331790800781,
                                        23.0693971992188
                                    ],
                                    [
                                        110.351597929688,
                                        23.1030886054688
                                    ],
                                    [
                                        110.291519804688,
                                        23.1284035468751
                                    ],
                                    [
                                        110.262899199219,
                                        23.1572536445312
                                    ],
                                    [
                                        110.295064726563,
                                        23.2119753242188
                                    ],
                                    [
                                        110.291666289063,
                                        23.2392971015626
                                    ],
                                    [
                                        110.302899199219,
                                        23.2482888007813
                                    ],
                                    [
                                        110.311790800781,
                                        23.2793971992188
                                    ],
                                    [
                                        110.322899199219,
                                        23.2882888007813
                                    ],
                                    [
                                        110.341790800781,
                                        23.3122731757813
                                    ],
                                    [
                                        110.316673613281,
                                        23.332387921875
                                    ],
                                    [
                                        110.343016386719,
                                        23.3684499335938
                                    ],
                                    [
                                        110.339549589844,
                                        23.3963259101563
                                    ],
                                    [
                                        110.362899199219,
                                        23.4282888007813
                                    ],
                                    [
                                        110.371790800781,
                                        23.4522731757813
                                    ],
                                    [
                                        110.351790800781,
                                        23.4682888007813
                                    ],
                                    [
                                        110.322899199219,
                                        23.5393971992188
                                    ],
                                    [
                                        110.301790800781,
                                        23.5482888007813
                                    ],
                                    [
                                        110.287843046875,
                                        23.5813918281251
                                    ],
                                    [
                                        110.261820097656,
                                        23.5781569648437
                                    ],
                                    [
                                        110.252376738281,
                                        23.6218068671876
                                    ],
                                    [
                                        110.229405546875,
                                        23.6402028632813
                                    ],
                                    [
                                        110.237703886719,
                                        23.7069338203125
                                    ],
                                    [
                                        110.215538359375,
                                        23.7182888007813
                                    ],
                                    [
                                        110.202899199219,
                                        23.6882888007813
                                    ],
                                    [
                                        110.170548125,
                                        23.6693971992188
                                    ],
                                    [
                                        110.174039335938,
                                        23.69745628125
                                    ],
                                    [
                                        110.161678496094,
                                        23.7184841132813
                                    ],
                                    [
                                        110.163031035156,
                                        23.7293679023438
                                    ],
                                    [
                                        110.117064238281,
                                        23.73931175
                                    ],
                                    [
                                        110.079478789063,
                                        23.7614064765625
                                    ],
                                    [
                                        110.067345,
                                        23.803843
                                    ],
                                    [
                                        110.093482695313,
                                        23.8377053046876
                                    ],
                                    [
                                        110.13298953125,
                                        23.86819846875
                                    ],
                                    [
                                        110.142000761719,
                                        23.8798757148438
                                    ],
                                    [
                                        110.191358671875,
                                        23.8604714179688
                                    ],
                                    [
                                        110.202974882813,
                                        23.9155275703125
                                    ],
                                    [
                                        110.23170046875,
                                        23.8981984687501
                                    ],
                                    [
                                        110.26298953125,
                                        23.88948753125
                                    ],
                                    [
                                        110.281805449219,
                                        23.8580251289063
                                    ],
                                    [
                                        110.294407988281,
                                        23.8598854804687
                                    ],
                                    [
                                        110.291549101563,
                                        23.8792336250001
                                    ],
                                    [
                                        110.307174101563,
                                        23.9051369453125
                                    ],
                                    [
                                        110.289810820313,
                                        23.9646804023438
                                    ],
                                    [
                                        110.31470828125,
                                        24.0280104804688
                                    ],
                                    [
                                        110.36298953125,
                                        24.03819846875
                                    ],
                                    [
                                        110.367345,
                                        24.0438430000001
                                    ],
                                    [
                                        110.377345,
                                        24.0438430000001
                                    ],
                                    [
                                        110.397345,
                                        24.0438430000001
                                    ],
                                    [
                                        110.397345,
                                        24.013843
                                    ],
                                    [
                                        110.3915246875,
                                        23.9976198554688
                                    ],
                                    [
                                        110.393709746094,
                                        23.9609645820313
                                    ],
                                    [
                                        110.382625761719,
                                        23.9485622382812
                                    ],
                                    [
                                        110.3520325,
                                        23.9291042304688
                                    ],
                                    [
                                        110.353238554688,
                                        23.908843
                                    ],
                                    [
                                        110.352030058594,
                                        23.8885720039063
                                    ],
                                    [
                                        110.382625761719,
                                        23.8791237617188
                                    ],
                                    [
                                        110.412064238281,
                                        23.8685622382813
                                    ],
                                    [
                                        110.442625761719,
                                        23.8591237617188
                                    ]
                                ]
                            ]
                        ]
                    }
                },
                {
                    type: "Feature",
                    properties: {
                        name: "覃塘区"
                    },
                    geometry: {
                        type: "MultiPolygon",
                        coordinates: [
                            [
                                [
                                    [
                                        109.371868925781,
                                        23.3877883125001
                                    ],
                                    [
                                        109.430360136719,
                                        23.3647951484376
                                    ],
                                    [
                                        109.44170046875,
                                        23.3794875312501
                                    ],
                                    [
                                        109.477345,
                                        23.383843
                                    ],
                                    [
                                        109.481851835938,
                                        23.36628440625
                                    ],
                                    [
                                        109.505513945313,
                                        23.3320119453125
                                    ],
                                    [
                                        109.529176054688,
                                        23.3156740546875
                                    ],
                                    [
                                        109.537345,
                                        23.303843
                                    ],
                                    [
                                        109.511790800781,
                                        23.2693971992188
                                    ],
                                    [
                                        109.502899199219,
                                        23.2382888007813
                                    ],
                                    [
                                        109.443917265625,
                                        23.2164846015625
                                    ],
                                    [
                                        109.439298125,
                                        23.1793410468751
                                    ],
                                    [
                                        109.481378203125,
                                        23.1616091132813
                                    ],
                                    [
                                        109.48297,
                                        23.1488161445313
                                    ],
                                    [
                                        109.472899199219,
                                        23.0682888007813
                                    ],
                                    [
                                        109.452899199219,
                                        23.0522731757813
                                    ],
                                    [
                                        109.472203398438,
                                        23.0482033515626
                                    ],
                                    [
                                        109.489527617188,
                                        23.0503591132813
                                    ],
                                    [
                                        109.532469511719,
                                        23.0380959296875
                                    ],
                                    [
                                        109.567345,
                                        23.0538430000001
                                    ],
                                    [
                                        109.576163359375,
                                        23.030903546875
                                    ],
                                    [
                                        109.561102324219,
                                        23.018843
                                    ],
                                    [
                                        109.573023710938,
                                        23.0092971015626
                                    ],
                                    [
                                        109.570213652344,
                                        22.9867116523438
                                    ],
                                    [
                                        109.604476347656,
                                        22.9909743476563
                                    ],
                                    [
                                        109.585819121094,
                                        22.959233625
                                    ],
                                    [
                                        109.651790800781,
                                        22.9314357734375
                                    ],
                                    [
                                        109.604622832031,
                                        22.9147560859376
                                    ],
                                    [
                                        109.585775175781,
                                        22.9382888007813
                                    ],
                                    [
                                        109.571790800781,
                                        22.9293971992188
                                    ],
                                    [
                                        109.561287871094,
                                        22.8690309882812
                                    ],
                                    [
                                        109.517345,
                                        22.833843
                                    ],
                                    [
                                        109.4837121875,
                                        22.8209157539063
                                    ],
                                    [
                                        109.446632109375,
                                        22.86722190625
                                    ],
                                    [
                                        109.472899199219,
                                        22.8782888007813
                                    ],
                                    [
                                        109.481790800781,
                                        22.8924123359376
                                    ],
                                    [
                                        109.411790800781,
                                        22.9182888007813
                                    ],
                                    [
                                        109.402899199219,
                                        22.9293971992188
                                    ],
                                    [
                                        109.381790800781,
                                        22.9382888007813
                                    ],
                                    [
                                        109.332899199219,
                                        22.9993971992188
                                    ],
                                    [
                                        109.309857207031,
                                        23.0178469062501
                                    ],
                                    [
                                        109.322899199219,
                                        23.0282888007813
                                    ],
                                    [
                                        109.345340605469,
                                        23.065239484375
                                    ],
                                    [
                                        109.329979277344,
                                        23.091372296875
                                    ],
                                    [
                                        109.251790800781,
                                        23.1082888007813
                                    ],
                                    [
                                        109.247345,
                                        23.133843
                                    ],
                                    [
                                        109.239022246094,
                                        23.154546125
                                    ],
                                    [
                                        109.250933867188,
                                        23.2237331367188
                                    ],
                                    [
                                        109.231385527344,
                                        23.2382741523438
                                    ],
                                    [
                                        109.233277617188,
                                        23.2492580390625
                                    ],
                                    [
                                        109.221412382813,
                                        23.2684279609375
                                    ],
                                    [
                                        109.225220976563,
                                        23.2905471015626
                                    ],
                                    [
                                        109.207345,
                                        23.303843
                                    ],
                                    [
                                        109.213111601563,
                                        23.3377858710938
                                    ],
                                    [
                                        109.266324492188,
                                        23.3595632148438
                                    ],
                                    [
                                        109.282323027344,
                                        23.3802907539063
                                    ],
                                    [
                                        109.333453398438,
                                        23.41819846875
                                    ],
                                    [
                                        109.36298953125,
                                        23.40948753125
                                    ],
                                    [
                                        109.371868925781,
                                        23.3877883125001
                                    ]
                                ]
                            ]
                        ]
                    }
                }
            ]
        };
        const myChart = echarts.init(this.$el.find('.map-container')[0]);
        echarts.registerMap('GuiGang', geoJson);
        myChart.setOption({
            tooltip: {
                trigger: 'item',
                formatter: params => `${params.name}<br/>${(params.data && params.data.value) ? params.data.value : ''}`
            },
            series: [{
                name: '导航地图',
                type: 'map',
                zoom: 1.2,
                label: {
                    show: true,
                    color: '#333',
                    fontSize: 8
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 12,
                        color: '#333'
                    }
                },
                mapType: 'GuiGang', // 自定义扩展图表类型
                data: [{
                    name: '平南县',
                    value: '',
                    itemStyle: {
                        normal: {
                            areaColor: '#FCD68D'
                        }
                    }
                },
                {
                    name: '港南区',
                    value: '',
                    itemStyle: {
                        normal: {
                            areaColor: '#C5E0F5'
                        }
                    }
                },
                {
                    name: '桂平市',
                    value: '',
                    itemStyle: {
                        normal: {
                            areaColor: '#D7E8BB'
                        }
                    }
                },
                {
                    name: '覃塘区',
                    value: '',
                    itemStyle: {
                        normal: {
                            areaColor: '#FDE5E5'
                        }
                    }
                },
                {
                    name: '港北区',
                    value: '',
                    itemStyle: {
                        normal: {
                            areaColor: '#FFF2AF'
                        }
                    }
                }
                ]
            }]
        });
        // myChart.on('click', (params) => {
        //   let city = params.name;
        //   console.log(params);
        //   params.data && params.data.value && console.log(params.data.value);
        // });
    }
}
module.exports = mapNav;
